// extracted by mini-css-extract-plugin
module.exports = {"ratingLabel":"nt","ratingLayout":"ot"};